var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('TableV',{attrs:{"nombre":"Usuarios Coordinador","table":_vm.user,"type":_vm.type,"headerss":_vm.header,"loadings":_vm.loading}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }